import React from "react";
import "./CatalogSection.scss";
import img1 from "../../images/CNCHAASVF0.png";
import img2 from "../../images/CNCHAASVF2.png";
import img3 from "../../images/TornoCNCST-25Y.png";

const CatalogSection = () => {
  const products = [
    {
      name: "CNC HAAS VF0",
      category: "Centro de maquinado CNC",
      description:
        "Equipo ideal para procesos de maquinado que requieren precisión, rendimiento y confiabilidad en operación industrial.",
      image: img1,
    },
    {
      name: "CNC HAAS VF2",
      category: "Centro de maquinado CNC",
      description:
        "Una solución versátil para producción y trabajo industrial con excelente capacidad de operación y control.",
      image: img2,
    },
    {
      name: "Torno CNC ST-25Y",
      category: "Torno CNC",
      description:
        "Equipo pensado para procesos de maquinado con precisión, consistencia y gran desempeño en producción.",
      image: img3,
    },
  ];

  return (
    <section className="catalog-section" id="catalogo">
      <div className="container">
        <div className="catalog-section__heading">
          <div className="catalog-section__eyebrow">Catálogo destacado</div>

          <h2 className="catalog-section__title">
            Conoce algunos de los equipos industriales que forman parte de
            nuestra oferta.
          </h2>

          <p className="catalog-section__subtitle">
            Esta sección está pensada como una base visual del catálogo. Más
            adelante podrá conectarse a base de datos para administrar productos,
            editar información y agregar nuevos equipos de manera dinámica.
          </p>
        </div>

        <div className="catalog-section__grid">
          {products.map((product, index) => (
            <article className="catalog-section__card" key={index}>
              <div className="catalog-section__image-box">
                <img src={product.image} alt={product.name} />
                <span className="catalog-section__category">
                  {product.category}
                </span>
              </div>

              <div className="catalog-section__content">
                <h3>{product.name}</h3>
                <p>{product.description}</p>

                <div className="catalog-section__actions">
                  <a
                    href="https://www.makinariadima.com/catalogo.php"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="catalog-section__btn catalog-section__btn--secondary"
                  >
                    Ver más
                  </a>

                  <a
                    href={`https://wa.me/525515898591?text=${encodeURIComponent(
                      `Hola, me interesa recibir información sobre la máquina: ${product.name}`
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="catalog-section__btn catalog-section__btn--primary"
                  >
                    Solicitar info
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="catalog-section__bottom">
          <a
            href="https://www.makinariadima.com/catalogo.php"
            target="_blank"
            rel="noopener noreferrer"
            className="catalog-section__main-cta"
          >
            Conoce todo nuestro catálogo
          </a>
        </div>
      </div>
    </section>
  );
};

export default CatalogSection;